import * as ct from 'countries-and-timezones';
import { DEFAULT_LANGUAGE } from './languagePreference';

const FRANCOPHONE_COUNTRIES = [
  'FR', 'BE', 'CH', 'LU', 'MC',
  'SN', 'CI', 'ML', 'BF', 'NE', 'TD', 'GN', 'BJ', 'TG',
  'CM', 'CG', 'CD', 'GA', 'CF', 'DJ', 'KM',
  'MG', 'MU', 'SC',
  'HT',
  'RW', 'BI',
];

function detectLanguageFromBrowser() {
  if (typeof navigator === 'undefined') {
    return null;
  }
  const tags = navigator.languages?.length
    ? navigator.languages
    : [navigator.language].filter(Boolean);
  for (const tag of tags) {
    const base = tag.split('-')[0]?.toLowerCase();
    if (base === 'fr') {
      return 'fr';
    }
    if (base === 'en') {
      return 'en';
    }
  }
  return null;
}

function detectLanguageFromTimezone() {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const countries = ct.getCountriesForTimezone(timezone);
    let isFrancophone = false;
    countries.forEach((country) => {
      if (FRANCOPHONE_COUNTRIES.includes(country.id)) {
        isFrancophone = true;
      }
    });
    return isFrancophone ? 'fr' : 'en';
  } catch (e) {
    return DEFAULT_LANGUAGE;
  }
}

export default function detectLanguage() {
  return detectLanguageFromBrowser()
    ?? detectLanguageFromTimezone();
}
